import { styled } from '@mui/material'

import { BlockLayout as BlockLayoutBase } from '../BlockLayout'

export const BlockLayout = styled(BlockLayoutBase)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    paddingTop: '0',
  },
}))
